import { Card } from '@rewind-ui/core'
import React, { useContext, useState } from 'react'
import { TbCircleArrowRightFilled } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import {
    HiInformationCircle, HiXMark
} from 'react-icons/hi2';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import { FcGoogle } from 'react-icons/fc';

import { TextInput, Button, Alert, Checkbox, Label, Spinner } from 'flowbite-react';
import { AppContext } from '../../../modules/contexts/AppContexts';

function RegisterCard({ userIsBusiness, closeAuth, switchToLogin }) {
    const [errorMessage, setErrorMessage] = useState();
    const { userSignUp, loading, setStartAuth } = useContext(AppContext);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const {
        getValues,
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        setErrorMessage(null);

        const userData = {
            first_name: '',
            last_name: '',
            username: data.user_email.split('@')[0],
            email: data.user_email,
            password: data.user_password,
            age_bracket: 'not specified',
            phone_num: '000 0000 0000',
            user_type: (userIsBusiness ? 'business' : 'idea'),
        }

        try {
            await userSignUp(userData);
            // If userLogin succeeds, navigate to the home page
            closeAuth()
        } catch (error) {
            // Handle error (e.g., set error message)
            setErrorMessage(error.message);
        }
    }

    const handleGoogleSignIn = () => {
        const clientId = "179883348163-30kg564rj670heq9n2ol2remfj7b24qn.apps.googleusercontent.com";
        const redirectUri = "https://unido-api.sustainable.co.ke/oauth2redirect";
        const scope = "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email";
        const responseType = "code";
        const accessType = "offline";

        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&access_type=${accessType}&redirect_uri=${encodeURIComponent(redirectUri)}`;
        window.location.href = authUrl;
    };

    return (
        <Card
            size='md'
            className='relative '
        >
            <Card.Header className='bg-gray-100'>
                <div className='flex justify-between flex-row w-full '>
                    <h3 className='text-xl w-3/4 tablet:w-fit tablet:text-4xl pt-2 font-semibold text-green_s5'>{userIsBusiness ? 'Create A Business Account' : 'Create an Idea Account'}</h3>
                    <Button
                        onClick={closeAuth}
                        color='red' pill className='pt-1 m-0'> <div className='flex flex-row items-center text-center gap-2 justify-center'><HiXMark className='text-xl mb-1' /> <p className='m-0 p-0 hidden tablet:flex'>CLOSE</p></div> </Button>
                </div>
            </Card.Header>

            <Card.Body className='max-h-[50vh] overflow-scroll'>
                <div className="w-full flex gap-5 flex-col justify-center items-center">
                    <p className='text-sm tablet:text-md desktop:text-base w-full tablet:w-3/4 text-justify tablet:text-center'>
                        The information marked with an <b className="after:content-['(*)'] after:ml-0.5 after:text-red-500">asterisk</b> will be publicly available on the community page. All other personally-identifiable information will be protected in line with Kenyan data protection regulation.
                    </p>
                    
                    <button 
                        onClick={handleGoogleSignIn}
                        className="flex shadow-lg flex-row bg-white hover:bg-gray-50 transition-colors py-3 gap-4 rounded-lg text-green_s5 w-full tablet:w-3/4 desktop:w-3/4 justify-center items-center"
                    >
                        <FcGoogle className='text-4xl' />
                        {userIsBusiness ? 'Sign Up With Google' : 'Sign Up With Google'}
                    </button>
                    <span className='gap-5 w-full text-center desktop:w-3/4 justify-center items-center flex'>- <b>OR</b> -</span>
                    
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        action="" className="w-full desktop:w-3/4 flex flex-col gap-7">

                        {errorMessage && <Alert color="failure" icon={HiInformationCircle}>
                            {errorMessage && <p>{errorMessage}</p>}
                        </Alert>}

                        <div className="flex flex-col tablet:flex-row w-full gap-7 tablet:gap-3">
                            <div className="flex flex-col !w-full">
                                <TextInput
                                    {...register("user_email", {
                                        required: 'Email Address is required.',
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: 'Invalid email address format.',
                                        },
                                    })}
                                    type="email"
                                    placeholder="Email Address *"
                                    className='w-full'
                                    color={errors.user_email?.message ? 'failure' : 'gray'}
                                    helperText={errors.user_email?.message ? errors.user_email?.message : (userIsBusiness ? 'Your company email will be your username upon successful account creation.' : 'Your email will be your username upon successful account creation.')}
                                />
                            </div>
                        </div>
                        
                        <div className="flex flex-col !w-full relative">
                            <TextInput
                                {...register("user_password", {
                                    required: 'Password is required.',
                                    minLength: {
                                        value: 8,
                                        message: 'Password must be at least 8 characters long.',
                                    },
                                })}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                className='w-full'
                                color={errors.user_password ? 'failure' : 'gray'}
                                helperText={errors.user_password?.message}
                            />
                            <span
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <HiEyeOff /> : <HiEye />}
                            </span>
                        </div>

                        <div className="flex flex-col w-full relative">
                            <TextInput
                                {...register("confirm_password", {
                                    required: 'Please confirm your password.',
                                    validate: (value) => value === getValues('user_password') || 'Passwords do not match.',
                                })}
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm Password"
                                className='w-full'
                                helperText={errors.confirm_password?.message}
                                color={errors.confirm_password ? 'failure' : (watch('user_password') === getValues('confirm_password') ? 'success' : 'gray')}
                            />
                            <span
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <HiEyeOff /> : <HiEye />}
                            </span>
                        </div>

                        <div className="flex items-center gap-2">
                            <Checkbox color={errors?.agree_terms ? 'failure' : 'gray'} id="accept" {...register('agree_terms', { required: 'You need to agree with terms and conditions' })} />
                            <Label htmlFor="accept" className={`${errors?.agree_terms ? 'text-red-600' : ''} flex`}>
                                I agree with the&nbsp;
                                <Link to={'/terms-conditions'} onClick={() => { setStartAuth(false) }} className="text-cyan-600 hover:underline dark:text-cyan-500">
                                    terms and conditions
                                </Link>
                            </Label>
                        </div>
                    </form>
                </div>
            </Card.Body>
            <Card.Footer className='bg-slate-100'>
                <div className="flex flex-col-reverse items-center  justify-center w-full gap-5">
                    <div className="flex flex-row justify-between w-full tablet:w-3/4">
                        <a href='mailto:hello@sustainable.co.ke' className='text-blue-600 ms-2 cursor-pointer w-full text-start text-sm'>
                            Having trouble creating an account?
                        </a>
                        <p className='flex flex-row gap-2 w-full items-end justify-end'>Already have an account? <p onClick={switchToLogin} className='cursor-pointer text-blue-600'>Log In</p></p>
                    </div>
                    <Button
                        onClick={handleSubmit(onSubmit)}
                        type='submit'
                        pill
                        color='blue'
                        disabled={loading}
                    >
                        <span className={`text-base font-medium`}>{'Create Account'}</span>
                        {loading ? <Spinner className='ms-3' /> : <TbCircleArrowRightFilled className={`text-xl ms-3 text-blue-500 md:text-0`} />}
                    </Button>
                </div>
            </Card.Footer>
        </Card>
    )
}

export default RegisterCard;
